import {
    IContentAPICatalog, IContentAPISearchItem, IContentAPIClientItem, IContentAPIFeature, IContentAPIFeatureOption, IContentAPIFeatureOptionGroup,
    IContentAPIItemVariantProposal, IContentAPIPricingReportItemAvailability, IContentAPISearchResult, IContentAPIFeatureGroup
} from "@cyncly/client-api-web-sdk-toolkit";
import React from "react";
import { strings } from 'strings';
import { WasherIcon, DecorationIcon, ArmchairIcon, TapIcon, CabinetsIcon, StorageIcon, LightingIcon, OfficeIcon, OutdoorIcon, MaterialsIcon, AllCatalogIcon, ArchitecturalIcon, FlooringIcon } from 'icons/';

export type OriginType = "TEST-HUB" | "AUTHORING-HUB" | "DESKTOP" | undefined;

export const enum EntityType {
    ATTRIBUTEGROUPS = "attributeGroups",
    ATTRIBUTES = "attributes",
    FEATUREGROUPS = "featureGroups",
    FEATURES = "features",
    ITEMGROUPS = "itemGroups",
    ITEMS = "items",
    MATERIALGROUPS = "materialGroups",
    MATERIALS = "materials",
    OPTIONGROUPS = "optionGroups",
    OPTIONS = "options",
}
export interface IIconProps {
    height?: number,
    width?: number,
    rotate?: number,
    color?: string
}

export type Config = 'displayCompany' | 'thumbnailSize' | 'itemView' | 'favorite' | 'hiddenCatalogs'  | 'theme' |
    'selectedTab' | 'selectedCatalogs' | 'selectedGroup' | 'openedGroup' | 'conf_thumbnailSize' |
    'conf_optionView' | 'previousSearch' | 'locale' | 'enable_contextualHelp' | 'selectedCatalogType' | 'conf_unionOption' | 'displayCatalogFiltering' | 'displayPricing' | 'enable_optionProposals' |
    'conf_thumbnailSize_style' | 'conf_optionView_style' | 'conf_thumbnailSize_subItem' | 'conf_optionView_subItem' | 'conf_thumbnailSize_light' | 'conf_optionView_light' |
    'catalogViewMode' | 'catalogGridSize' | 'catalogSortBy' | 'lastVisitedDate' | 'workingOffline';;

export interface ICatalogPlus extends IContentAPICatalog {
    rootId: string,
    version: string,
    isSelected: boolean,
    isVisible: boolean,
    isHidden: boolean,
}
export interface IOfflineCatalog extends ICatalogPlus {
    availableVersionsIds: Array<string>,
    offlineVersionIds: Array<IOfflineVersionInfo>,
    latestVersionId?: string,
    hasNewerVersion: boolean,
    nbrOfVersions: number,
}

export interface IOfflineVersionInfo {
    id: string,
    version: string,
    status: string,
    size: number,
}

export type CatalogViewMode = 'grid' | 'list';

export type CatalogSortBy = 'nameAZ' | 'nameZA' | 'categoryAZ' | 'categoryZA' | 'activationDate';

export type CatalogAvailabilityFlag = 'new' | 'updated' | undefined;

export const CATALOG_GRID_SIZE_MIN: number = 180;
export const CATALOG_GRID_SIZE_MAX: number = 300;
export const CATALOG_NEW_OR_UPDATED_WINDOW_DAYS: number = 60; //window (in days) used to flag a catalog as "new" or "recently updated"

export const catalogSortOptions: Array<[CatalogSortBy, string]> = [
    ['nameAZ', strings['catalog.sort.nameAZ']],
    ['nameZA', strings['catalog.sort.nameZA']],
    ['categoryAZ', strings['catalog.sort.categoryAZ']],
    ['categoryZA', strings['catalog.sort.categoryZA']],
    ['activationDate', strings['catalog.sort.activationDate']]
];

export type CatalogQuickFilter = 'all' | 'new' | 'updated';

export const catalogQuickFilters: Array<[CatalogQuickFilter, string]> = [
    ['all', strings['catalog.quickFilter.all']],
    ['new', strings['catalog.quickFilter.new']],
    ['updated', strings['catalog.quickFilter.updated']],
];


export interface xCatFacetInterface {
    facets: Array<IFacet>,
    updatedFacets: Array<IFacet> | null
    filterFacets: IOptionsGetItemFeatureOptions,
    totalResults: number
}

export interface ICatalogWithFeatures extends ICatalogBaseInfo {
    versionId?: string,
    features?: IFeaturePlus[],
    featureGroups?: IFeatureGroupPlus[]
}
export type CATALOG_STATUSES = 'activated' | 'inProgress' | 'inReview';

export type DisplayViewType = 'gallery' | 'list';

export type DisplayCompanyType = 'sort' | 'side' | 'hide';

export type DisplayViewerType = '2d' | '3d';

export const DEFAULT_NB_PER_PAGE = 10;

export type CatalogMenuItem = {
    title: string,
    name: string,
    path: string,
    visible: boolean,
    mainCategories: string | Array<string>,
    icon: JSX.Element
};

export const IconSize = {
    height: 16,
    width: 16
};
export const SideNavigationIconsize = {
    height: 24,
    width: 24
};
export const CatalogFilterIconsize = {
    height: 16,
    width: 16
};

export interface IItemPlus extends IContentAPISearchItem {
    selectedProposal: IContentAPIItemVariantProposal | undefined,
    isFavourite: boolean,
    tabIndex: number | undefined,
    price: number | undefined,
    currencyCode: string | undefined,
    availableInfo: IContentAPIPricingReportItemAvailability | undefined,
}
export interface IPricingItem {
    itemId: string,
    instanceId: string,
} 
export interface IItemGroupPlus extends IItemGroup {
    parentGroup?: Array<string>
}
export interface IFetchItemsOptions {
    searchQuery: string,
    nbPerPage: number,
    selectedCatalogs: Array<ICatalogPlus>,
    selectedGroup: IItemGroupPlus | undefined,
    itemList?: Array<IItemPlus>,
    totalResults?: number,
    selectedFacets: ISearchClassifications,
    selectedDimensions: IDimensionFilters,
    selectedSorting: sorting,
}

export interface featureOptionResult {
    optionName: string,
    numberOfItem: number,
    actualItems: Array<IContentAPIClientItem>,
    facets: Array<IFacet>,
    updatedFacets: Array<IFacet> | null,
    catalogsFacet: Array<IFacetValue> | null,
    companiesFacet: Array<IFacetValue> | null,
    updatedCatalogFacet: Array<IFacetValue> | null,
    updatedCompaniesFacet: Array<IFacetValue> | null,
}

export interface IInputValidationResult {
    originalInput: string,
    outputValue: number | undefined,
    errorOutput: string | undefined
}

export interface IFetchItemResults {
    totalResults: number,
    itemList: Array<IItemPlus>,
    facets: Array<IFacet>,
    updatedFacets: Array<IFacet> | null,
    dimensionFacets: Array<IFacet>,
    updatedDimensionFacets: Array<IFacet> | null,
    baseItemTypes: Array<IFacetValue>,
    updatedBaseItemTypes: Array<IFacetValue> | null,
    catalogsFacet: Array<IFacetValue> | null,
    companiesFacet: Array<IFacetValue> | null,
    updatedCatalogFacet: Array<IFacetValue> | null,
    updatedCompaniesFacet: Array<IFacetValue> | null,
    hasError: boolean,
    errorContent: string,
    deactivatedCatalogVersions: Array<ICatalogVersionErrorDetail> | undefined,
    unavailableCatalogVersions: Array<ICatalogVersionErrorDetail> | undefined,
    catalogsAutoUpdated: Array<ICatalogPlus> | undefined;
}

export interface IFetchCatalogsResults {
    catalogs: Array<ICatalogPlus>,
    hasError: boolean,
    errorContent: string
}

export interface IFetchGroupOptions {
    selectedCatalogs: Array<ICatalogPlus>
}

export interface IFetchGroupResults {
    groupList: Array<IItemGroup>
}

export type Favorite = {
    code: string,
    groupCodes: Array<string>
}

export interface IFeaturePlus extends IContentAPIFeature {
    //itemUUID?: string | null,
    options?: Array<IContentAPIFeatureOption | IContentAPIFeatureOptionGroup> | undefined,
    searchResult?: ISearchResultPlus
    //updatedFacets?: Array<IFacet> | null
}
export interface ISearchResultPlus extends IContentAPISearchResult {
    updatedFacets?: Array<IFacet> | null | undefined,
    updatedCatalogFacet?: Array<IFacetValue> | null | undefined,
    updatedCompanieFacet?: Array<IFacetValue> | null | undefined,
}
export interface IFeatureGroupPlus extends IContentAPIFeatureGroup {
    itemUUID?: string | null,
    versionId?: string
}

export type FeatureOptionsViewType = 'style' | 'cross' | 'light' | 'multiselect';

export type OptionJobQueue = {
    featureOption: IContentAPIFeatureOption,
    feature: IFeaturePlus,
    filteredItemContextList?: Array<IContentAPIClientItem>,
    refreshAfter?: boolean,
}

export type sorting = {
    name: string;
    type: 'text' | 'dimension';
    field: undefined | 'name' | 'width' | 'height' | 'depth';
    order: undefined | 'asc' | 'desc';
}

export type NullableFeature = null | IFeaturePlus | IFeatureGroupPlus;
export type NullableFacetValuesMap = Map<string, Array<string>> | undefined; // facetValues by facetCodes
export type PersistSubItems = Map<string, boolean> //persited subItems choice -open close...

export const catalogMenus: CatalogMenuItem[] = [        
    { title: strings['catalog.type.all.catalogs'], name: strings['catalog.type.all.catalogs'], path:'all', mainCategories: ['all'], visible: true, icon: <AllCatalogIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.kitchen'], name: strings['catalog.type.kitchen'], path:'kitchen', mainCategories: ['cabinetry'], visible: true, icon: <CabinetsIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.bathroom'], name: strings['catalog.type.bathroom'], path:'bathroom', mainCategories: ['sinks', 'faucets'], visible: true, icon: <TapIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.bedroom'], name: strings['catalog.type.bedroom'], path:'bedroom', mainCategories: ['architectural items'], visible: true, icon: <ArmchairIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.appliances'], name: strings['catalog.type.appliances'], path:'appliances', mainCategories: ['appliances'], visible: true, icon: <WasherIcon {...CatalogFilterIconsize}/> },   
    { title: strings['catalog.type.decorate'], name: strings['catalog.type.decorate'], path:'decorate', mainCategories: ['deco/accessories'], visible: true, icon: <DecorationIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.storage'], name: strings['catalog.type.storage'], path:'storage', mainCategories: ['storage'], visible: true, icon: <StorageIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.lighting'], name: strings['catalog.type.lighting'], path:'lighting', mainCategories: ['lighting'], visible: true, icon: <LightingIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.office'], name: strings['catalog.type.office'], path:'office', mainCategories: ['office'], visible: true, icon: <OfficeIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.outdoor'], name: strings['catalog.type.outdoor'], path:'outdoor', mainCategories: ['outdoor products'], visible: true, icon: <OutdoorIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.architectural'], name: strings['catalog.type.architectural'], path:'architectural', mainCategories: ['architectural items'], visible: true, icon: <ArchitecturalIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.material'], name: strings['catalog.type.material'], path:'materials', mainCategories: ['materials'], visible: true, icon: <MaterialsIcon {...CatalogFilterIconsize}/> },
    { title: strings['catalog.type.flooring'], name: strings['catalog.type.flooring'], path:'flooring', mainCategories: ['flooring'], visible: true, icon: <FlooringIcon {...CatalogFilterIconsize}/> }
];

export const catalogStatus = [
    ['all', strings['catalog.status.all']],
    ['visible', strings['catalog.status.visible']],
    ['hidden', strings['catalog.status.hidden']],
    ['lock', strings['catalog.status.lock']],
    ['pending', strings['catalog.status.pending']],
    ['denied', strings['catalog.status.denied']],
];

export const catalogType = [
    ['all', strings['catalog.type.all']],
    ['kitchen', strings['catalog.type.kitchen']],
    ['bathroom', strings['catalog.type.bathroom']],
    ['bedroom', strings['catalog.type.bedroom']],
    ['appliancees', strings['catalog.type.appliances']],
    ['decorate', strings['catalog.type.decorate']]
];

export type handlePosition = 'topLeft' | 'topCenter' | 'topRight' | 'topVertLeft' | 'topVertCenter' | 'topVertRight' |
    'topLeftDiagoLeft' | 'topLeftDiagoRight' | 'topRightDiagoLeft' | 'topRightDiagoRight' |
    'centerLeft' | 'centerCenter' | 'centerRight' | 'centerVertLeft' | 'centerVertCenter' | 'centerVertRight' |
    'centerLeftDiagoLeft' | 'centerLeftDiagoRight' | 'centerCenterDiagoLeft' | 'centerCenterDiagoRight' | 'centerRightDiagoLeft' | 'centerRightDiagoRight' |
    'bottomLeft' | 'bottomCenter' | 'bottomRight' | 'bottomVertLeft' | 'bottomVertCenter' | 'bottomVertRight' |
    'bottomLeftDiagoLeft' | 'bottomLeftDiagoRight' | 'bottomRightDiagoLeft' | 'bottomRightDiagoRight' |
    'none' | 'custom';

export const openingTypes = [
    ['Door', 'door', 'customNumeric'], 
    ['Drawer', 'drawer', 'customNumeric'], 
    ['General', 'general', 'customNumeric'], 
    ['Sliding', 'door.sliding', 'customNumeric'],
    ['Bifold', 'door.bifold', 'customNumeric'],
    ['Accordion', 'door.accordion', 'customNumeric'], 
    ['RollUp', 'door.rollUp', 'customNumeric'], 
    ['LiftUp', 'door.liftUp', 'customNumeric'], 
    ['TiltOut', 'door.tiltOut', 'customNumeric'],
    ['Toggle', undefined, 'toggle'],
    ['SingleSelect', undefined, 'singleSelect'],
    ['SingleSelect', 'general', 'singleSelect'],
    //['unknown', undefined, undefined]
];

export const positioningTypes = [
    ['Door', 'handle.door', 'singleSelect'], 
    ['Drawer', 'handle.drawer', 'singleSelect'], 
];